import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestJobsSkipPost = {
    path: "/jobs/skip",
    method: RouteHttpVerb.POST
};
export { locationRestJobsSkipPost };
